/**
 * Product Tabs Module
 * Handles tab switching for product categories (Fan Favourites section)
 */

/**
 * Switch between product category tabs
 * @param {string} tabName - Name of the tab to activate ('all', 'men', 'women', 'accessories')
 */
window.switchTab = function (tabName) {
  console.log('Switching to tab:', tabName)

  document.querySelectorAll('.tab-button').forEach(function (button) {
    button.classList.remove('active', 'border-primary', 'text-primary')
    button.classList.add('border-transparent')
  })

  document.querySelectorAll('.tab-content').forEach(function (content) {
    content.classList.remove('active')
  })

  const activeButton = document.querySelector('[data-tab="' + tabName + '"]')
  if (activeButton) {
    activeButton.classList.add('active', 'border-primary', 'text-primary')
    activeButton.classList.remove('border-transparent')
  }

  const activeContent = document.querySelector('[data-content="' + tabName + '"]')
  if (activeContent) {
    activeContent.classList.add('active')
    console.log('Active content found:', activeContent)

    setTimeout(function () {
      const swiper = activeContent.swiper
      if (swiper) {
        console.log('Updating swiper')
        swiper.update()
        swiper.slideTo(0)
      }
    }, 50)
  } else {
    console.error('No content found for tab:', tabName)
  }
}
